export default "__VITE_ASSET__DmR79wzu__"